/*是否合法IP地址*/
export function validateIP(rule, value, callback) {
    if (value == '' || value == undefined || value == null) {
        callback();
    } else {
        const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        if ((!reg.test(value)) && value != '') {
            callback(new Error('请输入正确的IP地址'));
        } else {
            callback();
        }
    }
}

/* 是否手机号码或者固话*/
export function validatePhoneTwo(rule, value, callback) {
    const reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;;
    if (value == '' || value == undefined || value == null) {
        callback();
    } else {
        if ((!reg.test(value)) && value != '') {
            callback(new Error('请输入正确的电话号码或者固话号码'));
        } else {
            callback();
        }
    }
}

/* 是否手机号码或者固话以及400、800*/
export function validatePhoneThree(rule, value, callback) {
    const reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9})|(400-\d{7,8})|(800-\d{7,8}))$/;;
    if (value == '' || value == undefined || value == null) {
        callback();
    } else {
        if ((!reg.test(value)) && value != '') {
            callback(new Error('请输入正确的电话号码或者固话号码'));
        } else {
            callback();
        }
    }
}

/* 是否是车牌号*/
export function validateCarNum(rule, value, callback) {
    const reg1 = /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$)/;
    const reg2 = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF])|([DF][A-HJ-NP-Z0-9][0-9]{4}))$/;

    if (value == '' || value == undefined || value == null) {
        callback();
    } else {
        if ((!reg1.test(value)) && (!reg2.test(value)) && value != '') {
            callback(new Error('请输入正确的车牌号码'));
        } else {
            callback();
        }
    }
}

/* 是否固话*/
export function validateTelphone(rule, value, callback) {
    const reg = /0\d{2,3}-\d{7,8}/;
    if (value == '' || value == undefined || value == null) {
        callback();
    } else {
        if ((!reg.test(value)) && value != '') {
            callback(new Error('请输入正确的固话（格式：区号+号码,如010-1234567）'));
        } else {
            callback();
        }
    }
}
/* 是否手机号码*/
export function validatePhone(rule, value, callback) {
    const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (value == '' || value == undefined || value == null) {
        callback();
    } else {
        if ((!reg.test(value)) && value != '') {
            callback(new Error('请输入正确的电话号码'));
        } else {
            callback();
        }
    }
}
/* 是否身份证号码*/
export function validateIdNo(rule, value, callback) {
    const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (value == '' || value == undefined || value == null) {
        callback();
    } else {
        if ((!reg.test(value)) && value != '') {
            callback(new Error('请输入正确的身份证号码'));
        } else {
            callback();
        }
    }
}
/* 是否邮箱*/
export function validateEMail(rule, value, callback) {
    const reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9-]+\.[a-z]+$/;
    if (value == '' || value == undefined || value == null) {
        callback();
    } else {
        if (!reg.test(value)) {
            callback(new Error('请输入正确的邮箱地址'));
        } else {
            callback();
        }
    }
}
/* 合法uri*/
export function validateURL(textval) {
    const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
    return urlregex.test(textval);
}

/*验证内容是否英文数字以及下划线*/
export function isPassword(rule, value, callback) {
    const reg = /^[_a-zA-Z0-9]+$/;
    if (value == '' || value == undefined || value == null) {
        callback();
    } else {
        if (!reg.test(value)) {
            callback(new Error('密码仅由英文字母，数字以及下划线组成'));
        } else {
            callback();
        }
    }
}

/*自动检验数值的范围*/
export function checkMax20000(rule, value, callback) {
    if (value == '' || value == undefined || value == null) {
        callback();
    } else if (!Number(value)) {
        callback(new Error('请输入[1,20000]之间的数字'));
    } else if (value < 1 || value > 20000) {
        callback(new Error('请输入[1,20000]之间的数字'));
    } else {
        callback();
    }
}

//验证数字输入框最大数值,32767
export function checkMaxVal(rule, value, callback) {
    if (value < 0 || value > 32767) {
        callback(new Error('请输入[0,32767]之间的数字'));
    } else {
        callback();
    }
}
//验证是否1-99之间
export function isOneToNinetyNine(rule, value, callback) {
    if (!value) {
        return callback(new Error('输入不可以为空'));
    }
    setTimeout(() => {
        if (!Number(value)) {
            callback(new Error('请输入正整数'));
        } else {
            const re = /^[1-9][0-9]{0,1}$/;
            const rsCheck = re.test(value);
            if (!rsCheck) {
                callback(new Error('请输入正整数，值为【1,99】'));
            } else {
                callback();
            }
        }
    }, 0);
}

// 验证是否整数
export function isInteger(rule, value, callback) {
    // if (!value) {
    //   return callback(new Error('输入不可以为空'));
    // }
    setTimeout(() => {
        if (isNaN(value)) {
            callback(new Error('请输入数字'));
        }
        // const re = /^[0-9]*[1-9][0-9]*$/;
        const re = /^[0-9]*[0-9][0-9]*$/;
        const rsCheck = re.test(value);
        if (!rsCheck) {
            callback(new Error('请输入整数'));
        } else {
            callback();
        }
    }, 0);
}
// 验证是否正整数,非必填
export function isIntegerNotMust(rule, value, callback) {
    // if (!value) {
    //   callback();
    // }
    setTimeout(() => {
        if (isNaN(value)) {
            callback(new Error('请输入数字'));
        }
        const re = /^[0-9]*[1-9][0-9]*$/;
        const rsCheck = re.test(value);
        if (!rsCheck) {
            callback(new Error('请输入正整数'));
        } else {
            callback();
        }
    }, 100);
}

// 验证是否是[0-1]的小数
export function isDecimal(rule, value, callback) {
    // if (!value) {
    //   return callback(new Error('输入不可以为空'));
    // }
    setTimeout(() => {
        if (!Number(value)) {
            callback(new Error('请输入[0,1]之间的数字'));
        } else {
            if (value < 0 || value > 1) {
                callback(new Error('请输入[0,1]之间的数字'));
            } else {
                callback();
            }
        }
    }, 100);
}

//是否是大于等于0得decimal
export function isDecimalThanZero(rule, value, callback) {
    // if (!value) {
    //   return callback(new Error('输入不可以为空'));
    // }
    setTimeout(() => {
        if (isNaN(value)) {
            callback(new Error('请输入数字'));
        }
        if (value < 0) {
            callback(new Error('请输大于0的数字'));
        } else {
            callback();
        }
    }, 100);
}

// 验证是否是[1-10]的整数,即不可以等于0
export function isBtnOneToTen(rule, value, callback) {
    if (typeof value == 'undefined') {
        return callback(new Error('输入不可以为空'));
    }
    setTimeout(() => {
        if (!Number(value)) {
            callback(new Error('请输入正整数，值为[1,10]'));
        } else {
            if (!(value == '1' || value == '2' || value == '3' || value == '4' || value == '5' || value == '6' || value == '7' || value == '8' || value == '9' || value == '10')) {
                callback(new Error('请输入正整数，值为[1,10]'));
            } else {
                callback();
            }
        }
    }, 100);
}
// 验证是否是[1-100]的小数,即不可以等于0
export function isBtnOneToHundred(rule, value, callback) {
    if (!value) {
        return callback(new Error('输入不可以为空'));
    }
    setTimeout(() => {
        if (!Number(value)) {
            callback(new Error('请输入整数，值为[1,100]'));
        } else {
            if (value < 1 || value > 100) {
                callback(new Error('请输入整数，值为[1,100]'));
            } else {
                callback();
            }
        }
    }, 100);
}
// 验证是否是[0-100]的小数
export function isBtnZeroToHundred(rule, value, callback) {
    if (!value) {
        return callback(new Error('输入不可以为空'));
    }
    setTimeout(() => {
        if (!Number(value)) {
            callback(new Error('请输入[1,100]之间的数字'));
        } else {
            if (value < 0 || value > 100) {
                callback(new Error('请输入[1,100]之间的数字'));
            } else {
                callback();
            }
        }
    }, 100);
}

// 验证端口是否在[0,65535]之间
export function isPort(rule, value, callback) {
    if (!value) {
        return callback(new Error('输入不可以为空'));
    }
    setTimeout(() => {
        if (value == '' || typeof(value) == undefined) {
            callback(new Error('请输入端口值'));
        } else {
            const re = /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;
            const rsCheck = re.test(value);
            if (!rsCheck) {
                callback(new Error('请输入在[0-65535]之间的端口值'));
            } else {
                callback();
            }
        }
    }, 100);
}
// 验证端口是否在[0,65535]之间，非必填,isMust表示是否必填
export function isCheckPort(rule, value, callback) {
    if (!value) {
        callback();
    }
    setTimeout(() => {
        if (value == '' || typeof(value) == undefined) {
            //callback(new Error('请输入端口值'));
        } else {
            const re = /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;
            const rsCheck = re.test(value);
            if (!rsCheck) {
                callback(new Error('请输入在[0-65535]之间的端口值'));
            } else {
                callback();
            }
        }
    }, 100);
}

/* 小写字母*/
export function validateLowerCase(str) {
    const reg = /^[a-z]+$/;
    return reg.test(str);
}
/*保留2为小数*/
export function validatetoFixedNew(str) {
    return str;
}

/* 大写字母*/
export function validateUpperCase(str) {
    const reg = /^[A-Z]+$/;
    return reg.test(str);
}

/* 大小写字母*/
export function validatAlphabets(str) {
    const reg = /^[A-Za-z]+$/;
    return reg.test(str);
}

export function validateNull(rule, value, callback, mes) {
    if (value == '' || value == null || value == 'undefined') {
        callback(new Error(mes));
    }
    callback();
}

export function verifyDiscountRate(rule, value, callback) {
    setTimeout(() => {
        //console.log(value);
        if (isNaN(value)) {
            callback(new Error('数字必须大于或等于0且小于1'));
        }
        if (value !== '' && value !== null && value !== 'undefined') {
            if (value < 0 || value >= 1) {
                callback(new Error('数字必须大于或等于0且小于1'));
            }
            if (value.length > 4) {
                callback(new Error('请保留两位小数'));
            }
        }
        callback();
    }, 100);
}

//验证时间段
export function validateTime(rule, value, callback) {
    let reg = /^(([0-1]?\d)|(2[0-4])):[0-5]?\d-(([0-1]?\d)|(2[0-4])):[0-5]?\d$/;
    if (value == '' || value == null || value == 'undefined') {
        callback();
        return
    }
    if (!reg.test(value)) {
        callback(new Error('请输入时间段，格式00:00-24:00'));
    }
    callback();
}

//验证长度（变量形式），长度，是否包含空格，是否包含特殊符号，是否验证全中文，是否验证全英文，是否验证全数字，是否是正整数
export function validateInput(rule, value, callback, minLen, maxLen, checkSpace, checkSign, checkCN, checkEN, checkNum, isStr, isNum) {
    setTimeout(() => {
        if (value == '' || value == null || value == 'undefined') {
            callback();
            return
        }
        //长度
        if (value.length < minLen) {
            callback(new Error('长度不能小于' + minLen));
        }
        if (value.length > maxLen) {
            callback(new Error('长度不能大于' + maxLen));
        }
        //验证空格
        if (checkSpace) {
            let reg = /^[^ ]+$/
            if (!reg.test(value)) {
                callback(new Error('不能包含空格'));
            }
        }
        if (checkSign) {
            let reg = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/
                // let reg=/((?=[\x21-\x7e]+)[^A-Za-z0-9])/
            if (reg.test(value)) {
                callback(new Error('不能包含任何特殊字符'));
            }
        }
        if (checkCN) {
            let reg = /.*[\u4e00-\u9fa5]{1,}.*/
            if (reg.test(value)) {
                callback(new Error('不能包含汉字'));
            }
        }
        if (checkEN) {
            let reg = /.*[a-zA-Z]{1,}.*/
            if (reg.test(value)) {
                callback(new Error('不能包含英文'));
            }
        }
        if (checkNum) {
            let reg = /.*[0-9]{1,}.*/
                // let reg = /^-?\d*\.{0,1}\d{0,6}$/
            if (reg.test(value)) {
                callback(new Error('不能包含数字'));
            }
        }
        if (isStr) {
            // 字母数字下划线
            let reg = /^[\u4e00-\u9fa5a-zA-Z0-9_-]+$/
            if (!reg.test(value)) {
                callback(new Error('必须是中英文,数字,或"_","-"'));
            }
        }
        if (isNum) {
            // 数字
            let reg = /^\d+$|^\d+[.]?\d{0,6}$/
            if (!reg.test(value)) {
                callback(new Error('必须数字，且小数位最多为6'));
            }
        }
        callback();
    }, 100);
}

/**
 * 校验充电订单号
 * @param rule
 * @param value
 * @param callback
 */
export function checkChargeOrderNo(rule, value, callback) {
    let regex = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/
    let reg = /.*[\u4e00-\u9fa5]{1,}.*/
    if (regex.test(value)) {
        callback(new Error('含非法字符'))
    }
    if (reg.test(value)) {
        callback(new Error('不能包含汉字'));
    }
    callback();
}

/**
 * 校验订单查询时的手机号
 * @param rule
 * @param value
 * @param callback
 */
export function checkPhone(rule, value, callback) {
    let phoneRegex = /^1(3|4|5|6|7|8|9)\d{9}$/
    if (!value) {
        callback();
    }
    if (!phoneRegex.test(value)) {
        callback(new Error("手机号格式有误"))
    }
    callback()
}

// 验证Sim卡长度
export function simCardLength(rule, value, callback) {
    setTimeout(() => {
        // if (isNaN(value)) {
        //   callback(new Error('请输入Sim卡卡号'));
        // }
        if (value.length === 13 || value.length === 20) {
            callback();
        } else {
            callback(new Error('sim卡卡号长度为13或20位'));
        }
    }, 0);
}

// 验证号码：手机号码、400电话
export function checkSomePhone(rule, value, callback) {
    setTimeout(() => {
        let reg = /(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$)|(^((\(\d{3}\))|(\d{3}\-))?(1[3578]\d{9})$)|(^(400)-(\d{3})-(\d{4})(.)(\d{1,4})$)|(^(400)-(\d{4})-(\d{3}$))|(^(400)-(\d{3})-(\d{4}$))/;
        if (!reg.test(value)) {
            callback(new Error('电话格式不正确'));
        } else {
            callback();
        }
    }, 0);
}


// WEBPACK FOOTER //
// ./src/common/validator.js